export const transactionType = [
  { value: 'transfer', text: 'From one payment system to another' },
  { value: 'budgetPayment', text: 'Budget payment' },
  { value: 'financialOperation', text: 'Investments and dividends' },
  { value: 'LPPayment', text: 'Investments LP and Withdrawals LP' },
  { value: 'other', text: 'Other type' },
  { value: 'commissionPayment', text: 'Commission payment' },
]

export const investmentTransactionType = [
  { value: 'investment', text: 'Investment' },
  { value: 'lp_dividend', text: 'LP Dividends' },
  { value: 'earning', text: 'Earnings' },
]
export const dividendTransactionType = [
  { value: 'dividends', text: 'Dividends' },
  { value: 'lp_investment', text: 'LP Investment' },
]
